import { render, staticRenderFns } from "./PolicyHasIndemnityModal.vue?vue&type=template&id=c5f0d702&scoped=true"
import script from "./PolicyHasIndemnityModal.vue?vue&type=script&lang=js"
export * from "./PolicyHasIndemnityModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c5f0d702",
  null
  
)

export default component.exports